/**
 * Single place for base-path / asset URL logic.
 * Prefer custom-domain root (`/`). Project Pages can set config.basePath later.
 */
let basePath = "/";

export function normalizeBase(path) {
  if (!path || path === "/") return "/";
  return path.endsWith("/") ? path : `${path}/`;
}

export function setBasePath(path) {
  basePath = normalizeBase(path);
  return basePath;
}

export function getBasePath() {
  return basePath;
}

export function asset(path) {
  const clean = String(path || "").replace(/^\.\//, "").replace(/^\//, "");
  return `${basePath}${clean}`;
}

export function consumeSpaRedirect() {
  const redirect = sessionStorage.getItem("ck-redirect");
  if (!redirect) return;
  sessionStorage.removeItem("ck-redirect");
  history.replaceState(null, "", redirect);
}
